import { ANALYTICS_EVENTS, ANALYTICS_PROPERTY_KEYS, COMPONENT_OUTCOMES, DCM_PAGES } from '../constants';
import { trackAnalyticsEvent } from '../core/analyticsClient';
import type { AnalyticsEventProperties } from '../types';
import {
  clearLoginFlowMarkers,
  getDurationSince,
  hadLoginFlowMfa,
  markLoginFlowStarted,
  readLoginFlowStartMs,
} from '../utils';

const getLoginFlowDurationProperties = (): AnalyticsEventProperties => {
  const startMs = readLoginFlowStartMs();

  return startMs ? { [ANALYTICS_PROPERTY_KEYS.DURATION_MS]: getDurationSince(startMs) } : {};
};

export const trackLoginFlowStarted = (): void => {
  markLoginFlowStarted();
  trackAnalyticsEvent(ANALYTICS_EVENTS.LOGIN_STARTED, {
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.LOGIN,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
  });
};

export const trackLoginFlowCompleted = (): void => {
  if (!readLoginFlowStartMs()) {
    return;
  }

  trackAnalyticsEvent(ANALYTICS_EVENTS.LOGIN_COMPLETED, {
    [ANALYTICS_PROPERTY_KEYS.HAD_MFA]: hadLoginFlowMfa(),
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.LOGIN,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
    ...getLoginFlowDurationProperties(),
  });
  clearLoginFlowMarkers();
};

export const trackLoginFlowFailed = (reason: string): void => {
  trackAnalyticsEvent(ANALYTICS_EVENTS.LOGIN_FAILED, {
    reason,
    [ANALYTICS_PROPERTY_KEYS.HAD_MFA]: hadLoginFlowMfa(),
    [ANALYTICS_PROPERTY_KEYS.PAGE]: DCM_PAGES.LOGIN,
    [ANALYTICS_PROPERTY_KEYS.COMPONENT_OUTCOME]: COMPONENT_OUTCOMES.USER,
    ...getLoginFlowDurationProperties(),
  });
};
